._Pagination_ivgjs_1 {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
